module.exports = __webpack_public_path__ + "img/a1.6ecfe5ad.jpg";